import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { useTranslation } from 'react-i18next';
import AOS from 'aos';
import 'aos/dist/aos.css';
import axios from 'axios';

import './News.css';

const News = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const [news, setNews] = useState([]);
  const [isReady, setIsReady] = useState(false); // 🔑 Swiper üçün vacibdir

  useEffect(() => {
    AOS.init({ duration: 2000, once: false });
  }, []);

  useEffect(() => {
    getBlogs();
  }, []);

  const getBlogs = async () => {
    try {
      const response = await axios.get(
        'https://cortex-site.runasp.net/api/Blogs'
      );
      setNews(response.data);
      setIsReady(true); // 🔥 data gəldikdən sonra Swiper açılır
    } catch (error) {
      console.error('Blog fetch error:', error);
    }
  };

  const getLocalizedField = (item, fieldBase) => {
    if (currentLanguage === 'en') return item[`${fieldBase}En`] || item[fieldBase];
    if (currentLanguage === 'ru') return item[`${fieldBase}Ru`] || item[fieldBase];
    return item[fieldBase];
  };

  if (!isReady || news.length === 0) return null;

  return (
    <div data-aos="fade-up" className="mt-[56px] md:mt-[88px]">
      <div className="w-full flex justify-center relative">
        <div className="md:max-w-container max-w-containerSm w-full mx-auto relative">

          {/* Header */}
          <div className="flex justify-between items-center h-[50px] mb-6">
            <p className="text-[24px] md:text-[32px] font-medium text-[#2a3d63]">
              {t("Bloq")}
            </p> 
 
            {news.length > 1 && (
              <div className="absolute top-0 right-0 flex gap-2">
            <button className="swiper-prev border-2 border-[#E5E5E5] group hover:border-[#2a3d63] p-[10px] rounded-lg">
              <i className="fa-solid fa-angle-left w-4 text-[#767676] group-hover:text-[#2a3d63]"></i>
            </button>
            <button className="swiper-next border-2 border-[#E5E5E5] group hover:border-[#2a3d63] p-[10px] rounded-lg">
              <i className="fa-solid fa-angle-right w-4 text-[#767676] group-hover:text-[#2a3d63]"></i>
            </button>
          </div>
            )}
          </div>

          {/* Swiper */}
          <Swiper
            modules={[Pagination, Navigation]}
            spaceBetween={30}
            slidesPerView={1}
            loop={news.length > 4}
            pagination={{ clickable: true }}
            navigation={
              news.length > 1
                ? {
                    nextEl: '.swiper-next',
                    prevEl: '.swiper-prev',
                  }
                : false
            }
            breakpoints={{
              640: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              1024: { slidesPerView: 4 },
            }}
          >
            {news.map((item) => (
              <SwiperSlide key={item.id}>
                <a href={`/${currentLanguage}/blogs/${item.id}`}>
                  <div className="group overflow-hidden rounded-lg">
                    <div className="relative">
                      <img
                        src={`https://cortex-site.runasp.net/${item.image}`}
                        alt={getLocalizedField(item, 'title')}
                        className="w-full h-[220px] object-cover transition-transform duration-300 group-hover:scale-105"
                      />
                      {/* <span className="absolute top-3 right-3 bg-[#F6FAFA] text-[#2a3d63] text-[12px] px-3 py-1 rounded-full">
                        {item.date}
                      </span> */}
                    </div>

                    <p className="mt-3 text-[#1C1C1C] font-secondFont">
                      {getLocalizedField(item, 'title')}
                    </p>
                  </div>
                </a>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default News;
